import React, { useState, useEffect } from 'react';
import * as S from './EditPassStyle';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { passwordService } from '../../Services/passwordService';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import { getClientIp } from '../../assets/utils';

const EditPass = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [code, setCode] = useState(null);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [message, setMessage] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const resetCode = searchParams.get('code');
        if (resetCode) {
            setCode(resetCode);
        } else {
            setMessage("Código de redefinição inválido ou ausente. Por favor, solicite um novo link.");
            setIsSuccess(false);
        }
    }, [searchParams]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!code) return;

        if (password.length < 6) {
            setMessage("A senha deve ter pelo menos 6 caracteres.");
            setIsSuccess(false);
            return;
        }
        if (password !== confirmPassword) {
            setMessage("As senhas não coincidem.");
            setIsSuccess(false);
            return;
        }

        setIsLoading(true);
        setMessage('');
        var ip = await getClientIp();

        try {
            const response = await passwordService.resetPassword(code, password, ip);
            setMessage(response.message);
            setIsSuccess(true);
            setTimeout(() => {
                navigate('/');
            }, 3000);
        } catch (error) {
            const errorMessage = error.response?.data?.message || "Ocorreu um erro. Tente novamente.";
            setMessage(errorMessage);
            setIsSuccess(false);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <S.Container>
            <S.BoxCenter>
                <S.Logo src="/logo-golden.png" alt="Golden Brasil" />
                <S.Title>CRIE SUA NOVA SENHA</S.Title>
                
                {!code || isSuccess ? (
                     <S.Message isSuccess={isSuccess}>{message}</S.Message>
                ) : (
                    <S.Form onSubmit={handleSubmit}>
                        <S.InputWrapper>
                            <S.Input 
                                type={showPassword ? 'text' : 'password'}
                                placeholder="Nova Senha"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                disabled={isLoading}
                            />
                            <S.ShowPassButton type="button" onClick={() => setShowPassword(!showPassword)}>
                                {showPassword ? <FiEyeOff /> : <FiEye />}
                            </S.ShowPassButton>
                        </S.InputWrapper>
                        <S.InputWrapper>
                            <S.Input 
                                type={showPassword ? 'text' : 'password'}
                                placeholder="Confirme a Nova Senha"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                disabled={isLoading}
                            />
                        </S.InputWrapper>
                        
                        <S.SubmitButton type="submit" disabled={isLoading}>
                            {isLoading ? 'SALVANDO...' : 'REDEFINIR SENHA'}
                        </S.SubmitButton>
                        
                        {message && <S.Message isSuccess={isSuccess}>{message}</S.Message>}
                    </S.Form>
                )}

                <S.BackLink onClick={() => navigate('/')}>Voltar para o Login</S.BackLink>
            </S.BoxCenter>
        </S.Container>
    );
};

export default EditPass;